import { Row, Col, Form, Button } from "react-bootstrap";
import {
  ArrowLeft,
  Plus,
  X,
  ArrowLeftShort,
  ArrowRightShort,
  PencilSquare,
  Trash,
  CircleSquare,
  XCircleFill,
} from "react-bootstrap-icons";
import CardTemplate from "../components/CardTemplate";
import UserUnlockCard from "../components/UserUnlockCard";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Api from "../services/request-service";
import { API_URL } from "../services/api_url";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

const RewardDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [rewardData, setRewardData] = useState({
    title: "",
    quantity: "",
    fancoins: "",
    image: null,
    is_rare: true,
    is_core: false,
  });



  const [loading, setLoading] = useState(false);
  const [userUnlockReward, setUserUnlockReward] = useState([]);
  const [rewardDetails, setRewardDetails] = useState(null);
  const itemsPerPage = 10;
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [focusedFields, setFocusedFields] = useState({});


  const handlePrevious = () => {
    let currentPageData = currentPage - 1;
    setCurrentPage(currentPage - 1);
    fetchUserUnlockReward(currentPageData);
  };

  const handleNext = () => {
    let currentPageData = currentPage + 1;
    setCurrentPage(currentPage + 1);
    fetchUserUnlockReward(currentPageData);
  };

  const fetchRewardDetails = async () => {
    try {
      setLoading(true);
      const response = await Api.get(API_URL.REWARD_DETAILS + id, true);
      if (response.status === 200) {
        setRewardDetails(response.data);
        const isRare = response.data.type === 'rare';
        const isCore = response.data.type === 'core';
        setRewardData({
          title: response.data.title,
          quantity: response.data.quantity,
          fancoins: response.data.fancoins,
          image: response.data.image.split("/").pop(),
          is_rare: isRare,
          is_core: isCore,
        });
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUserUnlockReward = async (page) => {
    try {
      const response = await Api.get(
        API_URL.USER_UNLOCK_REWARD +
        `?page=${page}&limit=${limit}&rewardId=${id}`,
        true
      );
      if (response.status === 200) {
        setUserUnlockReward(response.data.userDrops);
        setHasNext(response.data.pagination.hasNextPage);
        setHasPrevious(response.data.pagination.hasPreviousPage);
        setTotalItems(response.data.pagination.totalItems);
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRewardDetails();
    fetchUserUnlockReward(currentPage);
  }, []);

  const handleDeactivateReward = async () => {
    try {
      const response = await Api.put(API_URL.DEACTIVATE_REWARD + id, {}, true);
      if (response.status === 200) {
        toast.success("Reward deactivated successfully");
        navigate("/");
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
    }
  };

  const handleDeleteReward = async () => {
    try {
      const response = await Api.delete(API_URL.DELETE_REWARD + id, {}, true);
      if (response.status === 200) {
        toast.success("Reward deleted successfully");
        navigate("/");

      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRewardData({
      ...rewardData,
      [name]: value
    });
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    
    if (name === 'is_rare' && checked) {
      setRewardData({
        ...rewardData,
        is_rare: true,
        is_core: false
      });
    } else if (name === 'is_core' && checked) {
      setRewardData({
        ...rewardData,
        is_rare: false,
        is_core: true
      });
    } else {
      setRewardData({
        ...rewardData,
        [name]: checked
      });
    }
  };

  const handleImageUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      let file = e.target.files[0];
      if (file.size > maxSize) {
        toast.warning("File size should not exceed 5MB.");
        e.target.value = ""; // Reset the input
        return;
      }
      setRewardData({
        ...rewardData,
        image: file
      });
    }
  };

  const handleEditReward = async () => {
    const ApiFormData = new FormData();
    ApiFormData.append('title', rewardData.title);
    if (!rewardData.is_core) {
      ApiFormData.append('quantity', rewardData.quantity);
    }
    ApiFormData.append('fancoins', rewardData.fancoins);
    if (typeof rewardData.image === 'object') {
      ApiFormData.append('file', rewardData.image);
    }
    ApiFormData.append('activated', true);
    ApiFormData.append('is_collectible', true);
    ApiFormData.append('is_rare', rewardData.is_rare);
    ApiFormData.append('is_core', rewardData.is_core);
    ApiFormData.append('type', rewardData.is_core ? 'core' : 'rare');
    try {
      const response = await Api.post(API_URL.EDIT_REWARD + id, ApiFormData, true, true);
      if (response.status === 200) {
        toast.success("Reward updated successfully");
        setIsEdit(false);
        fetchRewardDetails();
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.log(error, "error....................");
      toast.error(error?.message || "Something went wrong");
      console.log(error);
    }
  };

  const handleCancelEdit = () => {
    setIsEdit(false);
    fetchRewardDetails();
  }

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <div className="d-flex align-items-center justify-content-start">
        <button className="backButton me-3" onClick={() => navigate("/")}>
          <ArrowLeft size={25} />
        </button>
        <p className="mb-0 fanstore-text">{isEdit ? "Edit Reward" : "View Reward"}</p>

      </div>
      <div className="d-flex align-items-center justify-content-end gap-3">
        {!isEdit ? rewardDetails?.activated && <PencilSquare size={25} onClick={() => setIsEdit(true)} />
          : <XCircleFill size={25} onClick={handleCancelEdit} />}
        <Trash size={25} color="red" onClick={handleDeleteReward} />
      </div>
    </div>
  );

  const bodyContent = (
    <Form /* onSubmit={handleSubmit} */>
      <div className={`${!isEdit && "opacity-25"}`}>
        <Form.Group className="mb-3 position-relative">
          <Form.Label className={`form-label pe-none transition-all ${focusedFields.title || rewardData.title
              ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
              : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
            }`}>Title</Form.Label>
          <Form.Control
            type="text"
            // placeholder="Title"
            name="title"
            value={rewardData.title}
            disabled={!isEdit}
            onChange={handleInputChange}
            onFocus={() => setFocusedFields(prev => ({ ...prev, title: true }))}
            onBlur={() => setFocusedFields(prev => ({ ...prev, title: false }))}
            className="formControl"
          />
        </Form.Group>
        {!rewardData.is_core && (
          <Form.Group className="mb-3 position-relative">
            <Form.Label className={`form-label pe-none transition-all ${focusedFields.quantity || rewardData.quantity
                ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
                : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
              }`}>Quantity</Form.Label>
            <Form.Control
              type="number"
              min={1}
              // placeholder="Quantity"
              name="quantity"
              value={rewardData.quantity}
              onChange={handleInputChange}
              onFocus={() => setFocusedFields(prev => ({ ...prev, quantity: true }))}
              onBlur={() => setFocusedFields(prev => ({ ...prev, quantity: false }))}
              className="formControl"
              disabled={!isEdit}
            />
          </Form.Group>
        )}
        <Form.Group className="mb-3 position-relative">
          <Form.Label className={`form-label pe-none transition-all ${focusedFields.fancoins || rewardData.fancoins
              ? "position-absolute top-0 start-0 translate-middle-y ms-3 bg-white px-2"
              : "position-absolute top-0 start-0 ms-3 bg-white px-2 translate-y-n10"
            }`}>Fancoins</Form.Label>
          <Form.Control
            type="number"
            min={1}
            // placeholder="Fancoins"
            name="fancoins"
            value={rewardData.fancoins}
            disabled={!isEdit}
            onChange={handleInputChange}
            onFocus={() => setFocusedFields(prev => ({ ...prev, fancoins: true }))}
            onBlur={() => setFocusedFields(prev => ({ ...prev, fancoins: false }))}
            className="formControl"
          />
        </Form.Group>
        <div className="mb-4 d-flex align-items-center justify-content-between">
          <input
            type="file"
            id="imageUpload"
            onChange={handleImageUpload}
            style={{ display: "none" }}
            accept="image/*"

          />
          <Button
            as="label"
            htmlFor="imageUpload"
            className="btnUpload"
            disabled={!isEdit}
          >
            {rewardData.image ? <X size={25} /> : <Plus size={25} />} Upload image
          </Button>
          <p className="mb-0 ellipsis">{rewardData?.image && typeof rewardData?.image !== "object" ? rewardData?.image : rewardData?.image?.name}</p>
        </div>
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <label htmlFor="is_rare" className='fw-600'>Rare Collectible</label>
          <label className="switch">
            <input name="is_rare" type="checkbox" id="is_rare" checked={rewardData.is_rare} onChange={handleSwitchChange} disabled={!isEdit} />
            <span className="slider"></span>
          </label>
        </div>
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <label htmlFor="is_core" className='fw-600'>Core Collectible</label>
          <label className="switch">
            <input name="is_core" type="checkbox" id="is_core" checked={rewardData.is_core} onChange={handleSwitchChange} disabled={!isEdit} />
            <span className="slider"></span>
          </label>
        </div>
      </div>
      <div>
        <Button
          // type={isEdit ? "submit" : "button"}
          className="btnActivate"
          disabled={!rewardDetails?.activated}
          onClick={isEdit ? handleEditReward : handleDeactivateReward}
        >
          {isEdit ? "Update" : "Deactivate"}
        </Button>
      </div>
    </Form>
  );
  return (
    <>
      <ToastContainer />
      {loading && <Loader loading={loading} />}
      <Row className="header-container">
        {totalItems > 10 && <Row className="mb-4 justify-content-between">
          <Col className="d-flex justify-content-end align-items-center">
            <button
              className="pagination-btn"
              onClick={handlePrevious}
              disabled={!hasPrevious}
            >
              <ArrowLeftShort
                size={26}
                color={hasPrevious ? "#FFFFFF" : "#1D1B20"}
              />
            </button>
            <span className="mx-2">{`${(currentPage - 1) * itemsPerPage + 1}-${currentPage * itemsPerPage
              } of ${totalItems}`}</span>
            <button
              className="pagination-btn"
              onClick={handleNext}
              disabled={!hasNext}
            >
              <ArrowRightShort
                size={26}
                color={hasNext ? "#FFFFFF" : "#1D1B20"}
              />
            </button>
          </Col>
        </Row>}

        <Col className="col-12 col-lg-4 mb-4">
          <CardTemplate
            headerContent={headerContent}
            bodyContent={bodyContent}
          />
        </Col>
        <Col className="col-12 col-lg-8">
          <UserUnlockCard userUnlockReward={userUnlockReward} />
        </Col>
      </Row>
    </>
  );
};

export default RewardDetails;
